/**
 * useNavigationTracking — Tracks page views on React Router navigation.
 *
 * Usage: Call useNavigationTracking() once in your root App component.
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '../services/heliosTelemetry';

export function useNavigationTracking(): void {
  const location = useLocation();
  const previousPage = useRef<string | null>(null);
  const previousTimestamp = useRef<number>(Date.now());

  useEffect(() => {
    const now = Date.now();
    const timeOnPrevious = previousPage.current ? now - previousTimestamp.current : 0;

    track('page_view', {
      page: location.pathname,
      previous_page: previousPage.current,
      time_on_previous_page_ms: timeOnPrevious,
    });

    previousPage.current = location.pathname;
    previousTimestamp.current = now;
  }, [location.pathname]);
}
